<template>
  <div class="not-found">
    <div class="not-found__col-icon">
      <vb-icon
        v-if="icon"
        class="not-found__icon"
        :name="icon"
        color="--primary"
        :size="115"
      />
    </div>
    <div class="not-found__col-content">
      <span class="not-found__title" v-html="text.title"></span>
      <span class="not-found__message" v-html="text.message"></span>
      <span class="not-found__suggestion" v-html="text.suggestion"></span>
      <slot name="default"></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'not-found',

    props: {
      icon: {
        type: String,
        default: 'face_thinking',
      },
      text: {
        type: Object,
        default: () => ({
          title: `<strong>Oops!</strong><br> Qualcosa non torna...`,
          message: `Potrebbero non esserci disponibilità per i criteri scelti.`,
          suggestion: `Prova a modificare la ricerca o esplora nuove destinazioni.`,
        }),
      },
    },
  };
</script>

<style lang="scss" scoped>
  .not-found {
    line-height: normal;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-top: $grid-gutter-width * 2;

    @include media-breakpoint-up(xl) {
      margin-top: $grid-gutter-width * 3;
    }

    &__col-icon {
      flex-shrink: 0;
      margin-right: $grid-gutter-width * 4/3;
    }

    &__col-content {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      text-align: left;
    }

    &__icon {
      color: var(--primary);

      &::after {
        content: '';
        display: block;
        height: 12px;
        margin-top: 10px;
        opacity: 30%;
        background-color: var(--primary);
        border-radius: 100%;
      }
    }

    &__title {
      color: var(--primary);
      font-weight: $vb-font-weight-semibold;
      font-size: 26px;

      ::v-deep {
        strong {
          font-weight: $vb-font-weight-semibold;
          font-size: 32px;
        }
      }
    }

    &__message {
      color: $gray-900;
      font-size: $font-size-xl;
      margin-top: $grid-gutter-width / 2;
    }

    &__suggestion {
      color: var(--primary);
      margin-top: $grid-gutter-width;
      font-weight: $vb-font-weight-semibold;
    }

    &__cta {
      margin-top: $grid-gutter-20;
    }
  }
</style>
